import { Action } from '@ngrx/store';

export class StocksWalletExchangeCheckoutAction implements Action {

    public static getInvestmentPortfolio = '[Stocks Wallet Exchange Checkout] get_investment_portfolio';
    public static getInvestmentPortfolioError = '[Stocks Wallet Exchange Checkout] get_investment_portfolio_error';
    public static getInvestmentPortfolioSuccess = '[Stocks Wallet Exchange Checkout] get_investment_portfolio_success';

    public static getInvestmentPortfolioBySlug = '[Stocks Wallet Exchange Checkout] get_investment_portfolio_by_slug_order';
    public static getInvestmentPortfolioBySlugError = '[Stocks Wallet Exchange Checkout] get_investment_portfolio_by_slug_error';
    public static getInvestmentPortfolioBySlugSuccess = '[Stocks Wallet Exchange Checkout] get_investment_portfolio_by_slug_success';

    public static newInvestmentPortfolioOrder = '[Stocks Wallet Exchange Checkout] new_investment_portfolio_order';
    public static newInvestmentPortfolioOrderError = '[Stocks Wallet Exchange Checkout] new_investment_portfolio_order_error';
    public static newInvestmentPortfolioOrderSuccess = '[Stocks Wallet Exchange Checkout] new_investment_portfolio_order_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
